import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21 13H3C2.447 13 2 13.448 2 14C2 14.552 2.447 15 3 15H5C5 18.519 7.614 21.432 11 21.92V24H13V21.92C16.386 21.432 19 18.519 19 15H21C21.553 15 22 14.552 22 14C22 13.448 21.553 13 21 13Z",
  class: "tw-text-primary-500",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19 7C19 3.14 15.859 0 12 0C8.141 0 5 3.14 5 7V11H19V7Z",
  class: "tw-text-primary-200",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }